import { Stack, Typography } from "@mui/material";
import AiIcon from "assets/icons/magic.svg";
import ActionButton from "common/components/ActionButton";
import SectionHeader from "common/components/SectionHeader";
import Tag from "common/components/Tag";
import useFetcher from "common/hooks/useFetcher";
import React from "react";
import toast from "react-hot-toast";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import echo from "./echo";

import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField
} from "@mui/material";
import { useState } from "react";

import SendIcon from "@mui/icons-material/Send";

import hljs from "highlight.js";
import "highlight.js/styles/github.css"; // You can choose any style you like
import { useEffect, useRef } from "react";

function extractCode(inputString) {
  // Regular expression to find text between ```python and ```
  const pattern = /```python([\s\S]*?)```/g;
  // Find all matches
  const codeSnippets = inputString.match(pattern);
  let code = "";

  if (codeSnippets) {
    codeSnippets.forEach(snippet => {
      // Remove the ```python and ``` markers and trim whitespace
      const cleanedSnippet = snippet.replace(/```python|```/g, "").trim();
      code += cleanedSnippet + "\n";
    });
  }

  return code;
}

export const CodeViewer = ({ code, language, showLineNumbers = true }) => {
  const codeRef = useRef(null);
  const [visible, setVisible] = useState(true);
  const [currentCode, setCurrentCode] = useState(code);

  useEffect(() => {
    if (codeRef.current) {
      hljs.highlightElement(codeRef.current);
    }
  }, [currentCode, language]);

  useEffect(() => {
    if (code === currentCode) return;
    setVisible(false);
    const timeoutId = setTimeout(() => {
      setCurrentCode(code);
      setVisible(true);
    }, 400); // Duration of fade-out

    return () => clearTimeout(timeoutId);
  }, [code]);

  return (
    <div
      style={{
        transition: "opacity 0.5s ease-in-out",
        opacity: visible ? 1 : 0,
        backgroundColor: "#171717",
        padding: "10px !important",
        borderRadius: "5px"
      }}
    >
      <SyntaxHighlighter
        language={language}
        style={{ ...echo }}
        showLineNumbers={showLineNumbers}
        wrapLines={true}
        lineProps={{
          style: {
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            fontSize: ".8rem"
          }
        }}
      >
        {code}
      </SyntaxHighlighter>
    </div>
    // <pre
    //   style={{
    //     transition: "opacity 0.3s ease-in-out",
    //     opacity: visible ? 1 : 0,
    //     backgroundColor: "#262626",
    //     whiteSpace: "pre-wrap",
    //     overflowWrap: "break-word",
    //     padding: "1em",
    //     borderRadius: "5px",
    //   }}
    // >
    //   <code ref={codeRef} className={`language-${language}`}>
    //     {currentCode}
    //   </code>
    // </pre>
  );
};

const ChatComponent = ({
  chat,
  code,
  removeChatHandler,
  chatHandler,
  updateCommandCode
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isSending, setIsSending] = useState(false);
  // console.log(chat, code);
  const handleSendMessage = async () => {
    if (inputValue.trim()) {
      setIsSending(true);
      await chatHandler(inputValue);
      setInputValue("");
      setIsSending(false);
    }
  };
  let history = [];
  try {
    history = chat
      ?.filter(({ role }) => role === "user")
      .map(({ content }) => content[0]?.text);
  } catch {
    history = [];
  }

  return (
    <Paper
      elevation={3}
      style={{
        height: "100%",
        padding: "10px",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {code ? (
        <Box style={{ flex: 1, overflowY: "auto", marginBottom: "10px" }}>
          <CodeViewer code={code} language={"python"} />
          {chat.length ? (
            <>
              <Typography sx={{ fontSize: "14px" }} variant="overline">
                Chat History
              </Typography>
              <List>
                {history.map((message, index) => (
                  <ListItem key={index} style={{ padding: 0 }}>
                    <Paper
                      elevation={2}
                      style={{
                        padding: "10px",
                        margin: "5px 0",
                        width: "100%"
                      }}
                    >
                      <ListItemText
                        sx={{
                          fontSize: "14px !important",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between"
                        }}
                        primary={message}
                        secondary={
                          history?.length > 1 &&
                          index === history?.length - 1 ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                              }}
                            >
                              <Button
                                style={{ marginTop: "10px" }}
                                color="info"
                                variant="contained"
                                onClick={removeChatHandler}
                              >
                                Remove
                              </Button>
                            </div>
                          ) : null
                        }
                      />
                    </Paper>
                  </ListItem>
                ))}
              </List>
            </>
          ) : null}
          {code && chat?.length ? (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "10px",
                marginRight: "10px"
              }}
            >
              <ActionButton icon="code" dark noload handler={updateCommandCode}>
                Update Command Code
              </ActionButton>
            </div>
          ) : // <Button
          //   style={{
          //     color: "#fff",
          //     backgroundColor: "#bb1fe2",
          //     marginTop: "10px",
          //   }}
          //   color="info"
          //   variant="contained"
          //   // startIcon={}
          //   onClick={() => {}}
          // >
          //   Update Command Code
          // </Button>
          null}
        </Box>
      ) : (
        <Paper
          elevation={3}
          style={{
            height: "100%",
            padding: "10px",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box
            style={{ flex: 1, overflowY: "auto", marginBottom: "10px" }}
          ></Box>
        </Paper>
      )}
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          borderRadius: "10px",
          padding: "10px",
          border: "1px solid grey"
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Describe the edits to this package you would like to make..."
          multiline
          maxRows={10}
          minRows={2}
          value={inputValue}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none"
            }
          }}
          autoComplete="off"
          autoFocus
          onChange={e => setInputValue(e.target.value)}
          onKeyPress={e => {
            if (e.key === "Enter" && !e.shiftKey) {
              handleSendMessage();
            }
          }}
        />
        <IconButton
          color="secondary"
          onClick={handleSendMessage}
          disabled={isSending}
        >
          {isSending ? (
            <CircularProgress color="secondary" size={24} />
          ) : (
            <SendIcon />
          )}
        </IconButton>
      </Box>
    </Paper>
  );
};

const OPTIMIZE_PROMPT = `
1. FIRST perform a thorough code review that includes,
   - Current code structure and patterns
   - Performance bottlenecks
   - Readability issues
   - Potential bugs or edge cases
3. FINALLY, update the code with the optimizations:
   - Clear comments
   - Efficient algorithms
   - Improved structure
   - Prefer logic that is unnested
`;

export default function CodeGenerator({ system, action, onClose, setCode }) {
  const fetcher = useFetcher();

  const [loading, setLoading] = React.useState(false);
  const [prompt, setPrompt] = React.useState("");
  const [chat, setChat] = React.useState([]);
  const [chatCode, setChatCode] = React.useState(
    window.editor.getSelectedText() || window.editor.getValue()
  );
  // console.log(window.editor.getValue());
  const chatHandler = async prompt => {
    if (prompt.length < 3) {
      return toast.error("Prompt must not be empty");
    }
    let defaultCode = null;
    let defaultSnippet = null;
    if (!chat.length) {
      let selectedText = window.editor.getSelectedText();
      if (selectedText) {
        defaultSnippet = selectedText;
      } else {
        defaultCode = window.editor.getValue();
      }
    }
    // setLoading(true);
    await fetcher.post(
      "generating response",
      `/api/ai/package/chat`,
      { prompt, chat, defaultCode, defaultSnippet },
      ({ error, code, chat }) => {
        if (error) {
          toast.error(error);
        }
        // if (code) {
        // if (defaultSnippet) {
        //   // const range = window.editor.getSelectionRange();
        //   // editor.session.replace(range, code);
        //   // setChatCode(window.editor.getValue());
        // } else {
        setChatCode(code);
        setChat(chat);
        // }
        // onClose();
      },
      // },
      () => {}
    );
    setLoading(false);
  };
  const removeChatHandler = () => {
    try {
      let newChat = [...chat];
      newChat.pop();
      newChat.pop();
      if (newChat.at(-1)?.role !== "assistant")
        return toast.error("cannot edit chat");
      let newCode = newChat.at(-1).content[0].text;
      newCode = extractCode(newCode);
      setChat(newChat);
      setChatCode(newCode);
    } catch {}
  };
  const updateCommandCode = () => {
    if (window.editor.getSelectedText()) {
      const range = window.editor.getSelectionRange();
      editor.session.replace(range, chatCode);
      setCode(window.editor.getValue());
    } else {
      setCode(chatCode);
    }
    onClose();
  };
  // const generateCode = async () => {
  //   if (prompt.length < 20) {
  //     return toast.error("Prompt must be at least 20 characters");
  //   }
  //   setLoading(true);
  //   await fetcher.post(
  //     "generating code",
  //     `/api/ai/command/code`,
  //     { prompt },
  //     ({ error, code }) => {
  //       if (error) {
  //         toast.error(error);
  //       }
  //       if (code) {
  //         setChatCode(code);
  //         onClose();
  //       }
  //     },
  //     () => {}
  //   );
  //   setLoading(false);
  // };
  // const changeCode = async (commandCode, passedPrompt, auto = false) => {
  //   if (!auto && prompt.length < 20) {
  //     return toast.error(
  //       "Prompt must be at least 20 characters and have at least 20 characters selected in code"
  //     );
  //   }
  //   setLoading(true);
  //   await fetcher.post(
  //     "refactoring code",
  //     `/api/ai/command/refactor`,
  //     { prompt: passedPrompt || prompt, commandCode },
  //     ({ error, code }) => {
  //       if (error) {
  //         toast.error(error);
  //       }
  //       if (code) {
  //         const range = editor.getSelectionRange();
  //         const modifiedText = code;
  //         editor.session.replace(range, modifiedText);
  //         setCode(window.editor.getValue());
  //         onClose();
  //       }
  //     },
  //     () => {}
  //   );
  //   setLoading(false);
  // };
  return (
    <Stack sx={{ position: "relative" }} p={2} gap={2}>
      <Stack
        p={2}
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <SectionHeader
          icon={<img height="30px" width="30px" src={AiIcon} />}
          large
        >
          Code Generator
        </SectionHeader>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <span style={{ fontSize: "1.2rem", fontFamily: "ECHELONONE" }}>
            <strong>ECHELON</strong>ONE AI
          </span>
          <Tag height={"20px"} label="Experimental" />
        </Stack>
      </Stack>
      <Stack sx={{ height: "85vh" }} m={0} className="floating" gap={2}>
        <ChatComponent
          chat={chat}
          removeChatHandler={removeChatHandler}
          updateCommandCode={updateCommandCode}
          code={chatCode}
          chatHandler={chatHandler}
        />
        {/* <Input
          size="small"
          dark
          sx={{ width: "100%" }}
          placeholder="Enter a prompt for a command you want to generate"
          value={prompt}
          multiline
          minRows={10}
          maxRows={10}
          onChange={(e) => setPrompt(e.target.value)}
        />
        <QuickTasks
          tasks={[
            {
              id: 1,
              label: "Comment to Code",
              content: "Convert comments to working code",
              type: "highlight",
            },
            {
              id: 2,
              label: "Optimize Code",
              content: OPTIMIZE_PROMPT,
              type: "highlight",
            },
            {
              id: 3,
              label: "Document Highlighted Code",
              content: "Add comments to code that describe what is happening",
              type: "highlight",
            },
          ]}
          onTaskSelect={(task) => {
            if (task.type === "highlight") {
              setPrompt(task.content);
              const selectedText = window.editor.getSelectedText();
              if (!selectedText) return toast.error("no code highlighted");
              changeCode(selectedText, task.content, true);
            }
          }}
        />
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <ActionButton
            icon="code"
            dark
            noload
            handler={async () => {
              await generateCode();
            }}
          >
            Generate Function
          </ActionButton>
          <ActionButton
            icon="compress"
            dark
            noload
            handler={async () => {
              const selectedText = window.editor.getSelectedText();
              // const range = editor.getSelectionRange();
              // const modifiedText = `<<<${selectedText}>>>`;
              // editor.session.replace(range, modifiedText);
              // console.log(window.editor.getValue());
              changeCode(selectedText);
            }}
          >
            Modify Selection
          </ActionButton>
        </div> */}
      </Stack>
    </Stack>
  );
}
